export class Trainer {
    constructor(
        public id: number,
        public firstName: string,
        public lastName: string,
        public company: string,
        public companyName: string,
        public email: string,
        public active: boolean,
        public trainerSkills: any[],
        public bio: string,
        public picturePath?: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/trainer/trainer.model.ts